import * as React from 'react';
import { useQuery as useQuery$2 } from '@apollo/client';
import { handleError } from './helpers.js';

const useQuery = (query, options)=>{
    const result = useQuery$2(query, options);
    const { error  } = result;
    React.useEffect(()=>{
        if (error) {
            handleError(query, error);
        }
    }, [
        error,
        query
    ]);
    return result;
};
var useQuery$1 = useQuery;

export { useQuery$1 as default };
//# sourceMappingURL=use-query.js.map
